// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-search__profile-container{display:flex;align-items:center;border:1px solid #E7E7E7;padding:2px}.select-search__profile-image{width:30px;height:30px;margin-right:15px;border-radius:100%}.select-search__name,.select-search__email{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n", ""]);
// Exports
module.exports = exports;
